import React from "react";
import "./ConfirmModal.css";

// A small custom replacement for window.alert / window.confirm used on the
// public signing page. When `cancelText` is null the modal acts as a simple
// alert (single confirm button); otherwise it's a confirm dialog.
const ConfirmModal = ({
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  danger = false,
  onConfirm,
  onCancel,
}) => {
  const isAlert = cancelText == null;

  return (
    <div className="confirm-modal-overlay" onClick={onCancel}>
      <div
        className="confirm-modal-content"
        onClick={e => e.stopPropagation()}
        role="alertdialog"
        aria-modal="true"
      >
        <div className="confirm-modal-header">
          <h2>{title}</h2>
        </div>

        <div className="confirm-modal-body">
          <p>{message}</p>
        </div>

        <div className="confirm-modal-footer">
          {!isAlert && (
            <button className="btn-secondary" onClick={onCancel}>
              {cancelText}
            </button>
          )}
          <button
            className={danger ? "btn-danger" : "btn-primary"}
            onClick={onConfirm}
            autoFocus
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
